module.exports = __webpack_public_path__ + "media/icons/dwg-file-f9b70694.png";